<template>
  <div :class="{
         btn: true,
         'dropdown-menu-item--disabled': disabled,
         'dropdown-menu-item--danger': danger,
         'dropdown-menu-item--active': active,
       }"
       :tabindex="disabled ? -1 : 0"
       :aria-disabled="disabled"
       :style="disabled ? 'pointer-events: none; opacity: 0.5;' : ''"
       @click="handleClick"
       @keydown.enter.prevent="handleClick"
       @keydown.space.prevent="handleClick"
  >
    <v-icon v-if="icon"
            :name="icon"
            :width="width"
            :height="height"
            :stroke="iconColor"
            :action-color="iconColor"
    />
    <span class="dropdown-menu-item__label">{{ label }}</span>
    <v-icon v-if="rightIcon"
            :name="rightIcon"
            :width="width"
            :height="height"
            :stroke="iconColor"
            :action-color="iconColor"
    />
  </div>
</template>

<script setup>
const props = defineProps({
  // Текст пункта меню
  label: {
    type: String,
    default: '',
  },
  // Подзаголовок
  subtitle: {
    type: String,
    default: '',
  },
  // Иконка слева
  icon: {
    type: String,
    default: '',
  },
  // Иконка справа
  rightIcon: {
    type: String,
    default: '',
  },
  // width
  width: {
    type: [String, Number],
    default: '20',
  },
  // height
  height: {
    type: [String, Number],
    default: 20,
  },
  // Размер иконок
  iconSize: {
    type: [String, Number],
    default: 20,
  },
  // Цвет иконок
  iconColor: {
    type: String,
    default: 'currentColor',
  },
  // Отключен ли пункт
  disabled: {
    type: Boolean,
    default: false,
  },
  // Опасное действие (красный цвет)
  danger: {
    type: Boolean,
    default: false,
  },
  // Активный пункт
  active: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['click']);

const handleClick = (event) => {
  if (props.disabled) {
    event?.preventDefault?.();
    return;
  }

  emit('click', event);
};
</script>

<style scoped>
.btn {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  margin: 0 8px;
  padding: 6px 8px;
  font: 400 14px/130% 'Inter', sans-serif;
  color: #595a5b;
  border-radius: 8px;
  user-select: none;
}

.btn:hover {
  background: rgba(var(--color-accent-rgb), 0.1);
  border-radius: 4px;
}

.dropdown-menu-item--active {
  background: rgba(var(--color-accent-rgb), 0.1);
  border-radius: 4px;
  font-weight: 500;
}

.dropdown-menu-item--danger {
  color: #fe4a49;
}

.dropdown-menu-item__label {
  flex: 1 1 auto;
  white-space: nowrap;
}
</style>
